import ModelGroup from './ModelGroup'
import Model from './Model'
import SpecificModelReason from './SpecificModelReason'
import ValidationType from './ValidationType'
export class ContactValidation {
    ID: number;
    ValidationTypeID: number;
    ValidationType: ValidationType;
    Value: string;
    Inactive: boolean;
}

export default ContactValidation;